import type { Bilingual } from ".";

// Bantuan, the buyers' chat (117U S10). Core copy: it shows on superadmin
// stores' pages, which ship only the storefront dictionaries.
export const bantuan: Bilingual = {
  ms: {
    "ban.open": "Buka Bantuan",
    "ban.close": "Tutup Bantuan",
    "ban.restart": "Mula semula",
    "ban.name": "Bantuan Sellhiz",
    "ban.online": "Jawapan serta-merta · staf dalam talian",
    "ban.offline": "Jawapan serta-merta · staf 8 pg–5 ptg, Isn–Sab",
    "ban.hello": "Hai! Tanya apa sahaja tentang pesanan, kelas atau pakej. Saya jawab serta-merta.",
    "ban.ph": "Tulis soalan anda…",
    "ban.send": "Hantar",
    "ban.chip.order": "Semak pesanan saya",
    "ban.chip.access": "Tak dapat akses",
    "ban.chip.class": "Link kelas",
    "ban.chip.sales": "Pakej & harga",
    "ban.chip.login": "Tak boleh log masuk",
    "ban.q.sales": "Apa pakej Sellhiz dan harganya?",
    "ban.q.order": "Saya nak semak pesanan saya",
    "ban.tech.prompt": "Boleh ceritakan masalah teknikal anda? Tulis di bawah, atau pilih yang paling dekat:",
    "ban.tech.login": "Tak boleh log masuk",
    "ban.tech.code": "Kod tak sampai ke emel",
    "ban.tech.pay": "Ralat semasa membayar",
    "ban.send.title": "Hantar akses ke emel anda",
    "ban.send.note": "Taip emel semasa beli. Pautan akses dan kelas dihantar terus ke emel itu, tiada kod.",
    "ban.send.btn": "Hantar ke emel saya",
    "ban.send.done": "Siap. Jika {email} ada pembelian, pautan akses dan kelas sudah dihantar ke emel itu. Semak Inbox, Spam atau Promotions dalam 2 minit.",
    "ban.send.other": "Tak sampai? Cuba emel lain",
    "ban.send.withCode": "Semak pesanan dengan kod",
    "ban.verify.title": "Sahkan emel semasa beli",
    "ban.verify.note": "Saya hantar kod 6 digit ke emel itu.",
    "ban.verify.email": "emel@anda.com",
    "ban.verify.send": "Hantar kod",
    "ban.verify.sending": "Menghantar…",
    "ban.verify.code": "Masukkan kod 6 digit",
    "ban.verify.check": "Sahkan",
    "ban.verify.again": "Hantar semula kod",
    "ban.verify.done": "Emel {email} disahkan.",
    "ban.verify.typo": "Emel semasa beli salah taip?",
    "ban.verify.titleRight": "Sahkan emel yang betul",
    "ban.verify.noteRight": "Saya hantar kod ke emel yang betul. Lepas itu, 4 digit akhir telefon untuk cari pesanan anda.",
    "ban.fix.title": "Cari pesanan di bawah emel yang salah taip",
    "ban.fix.note": "Masukkan 4 digit akhir nombor telefon yang anda isi semasa beli.",
    "ban.fix.phone": "4 digit akhir telefon",
    "ban.fix.typed": "Emel yang ditaip semasa beli (jika ingat)",
    "ban.fix.go": "Cari & betulkan",
    "ban.fix.busy": "Mencari…",
    "ban.fix.miss": "Tiada pesanan sepadan dengan 4 digit itu. Baki cubaan: {n}.",
    "ban.fix.done": "Siap! {n} pesanan kini di bawah {email}. Pautan akses dihantar semula ke emel itu.",
    "ban.fix.pending": "Jumpa {n} pesanan di bawah {old}. Staf akan sahkan dan kemas kini ke {email}, biasanya dalam waktu pejabat. Kami maklumkan di sini.",
    "ban.fix.staff": "Saya serahkan kepada staf untuk semak. Mereka akan balas di sini dan melalui emel anda.",
    "ban.acct.hello": "Hai {name}. Saya kenal pembelian anda, jadi tak perlu sahkan emel.",
    "ban.acct.helloNoName": "Hai! Saya kenal pembelian anda, jadi tak perlu sahkan emel.",
    "ban.tile.akses": "Akses saya",
    "ban.tile.kelas": "Kelas & WhatsApp",
    "ban.tile.rakaman": "Rakaman",
    "ban.tile.sijil": "Sijil",
    "ban.tile.resit": "Resit",
    "ban.tile.emel": "Tukar emel",
    "ban.tile.akses.q": "Mana akses produk saya?",
    "ban.tile.kelas.q": "Mana pautan kelas dan WhatsApp?",
    "ban.tile.rakaman.q": "Ada rakaman kelas?",
    "ban.tile.sijil.q": "Macam mana nak dapat sijil?",
    "ban.tile.resit.q": "Saya perlukan resit",
    "ban.tile.emel.q": "Saya nak tukar emel akaun",
    "ban.tile.akses.a": "Ini semua pembelian anda. Tekan untuk buka terus.",
    "ban.tile.akses.none": "Belum ada akses aktif pada akaun ini. Kalau anda baru bayar, akses sampai dalam beberapa minit.",
    "ban.tile.kelas.a": "Kelas anda yang seterusnya:",
    "ban.tile.kelas.none": "Tiada kelas akan datang dalam pembelian anda.",
    "ban.tile.kelas.when": "{when} · Zoom",
    "ban.tile.rakaman.a": "Rakaman sudah siap.",
    "ban.tile.rakaman.notYet": "Rakaman belum siap. Ia dimuat naik selepas kelas tamat.",
    "ban.tile.rakaman.none": "Tiada kelas dalam pembelian anda.",
    "ban.tile.rakaman.sub": "Tonton dalam halaman akses",
    "ban.tile.sijil.a": "Sijil anda:",
    "ban.tile.sijil.later": "Sijil dibuka selepas kelas tamat, {when}.",
    "ban.tile.sijil.none": "Tiada sijil untuk pembelian anda.",
    "ban.tile.sijil.name": "Nama pada sijil: {name}",
    "ban.tile.sijil.ready": "Sedia dituntut",
    "ban.tile.resit.a": "Resit setiap pembelian anda:",
    "ban.tile.resit.none": "Belum ada pembelian berbayar.",
    "ban.tile.resit.sub": "{date} · {store}",
    "ban.tile.emel.a": "Emel akaun anda: {email}. Saya hantar kod ke emel baharu untuk sahkan, kemudian semua pembelian ikut ke emel itu.",
    "ban.tile.emel.title": "Tukar emel akaun",
    "ban.tile.emel.sub": "Kod {n} digit ke emel baharu",
    "ban.tile.type.digital": "Produk digital · {store}",
    "ban.tile.type.kelas": "Kelas · {store}",
    "ban.tile.type.physical": "Produk fizikal · {store}",
    "ban.tile.btn.open": "Buka",
    "ban.tile.btn.resend": "Hantar ke emel",
    "ban.tile.btn.zoom": "Masuk Zoom",
    "ban.tile.btn.wa": "Kumpulan WhatsApp",
    "ban.tile.btn.watch": "Tonton",
    "ban.tile.btn.claim": "Tuntut sijil",
    "ban.tile.btn.viewCert": "Lihat sijil",
    "ban.tile.btn.certName": "Tukar nama pada sijil",
    "ban.tile.btn.pdf": "Muat turun PDF",
    "ban.tile.btn.newEmail": "Masukkan emel baharu",
    "ban.tile.foot": "0 token · jawapan templat daripada data pembelian anda",
    "ban.acct.new": "emel.baharu@anda.com",
    "ban.acct.send": "Hantar kod",
    "ban.acct.code": "Masukkan kod {n} digit",
    "ban.acct.confirm": "Tukar emel",
    "ban.acct.sentTo": "Kod dihantar ke {email}.",
    "ban.acct.done": "Emel akaun kini {email}. Semua pembelian anda ikut ke emel itu.",
    "ban.acct.doneStaff": "Emel akaun kini {email}. Sebahagian pembelian perlu disemak staf; mereka akan balas di sini.",
    "ban.acct.others": "Pembelian dari kedai lain dijawab oleh penjual kedai itu.",
    "ban.acct.contact": "Hubungi penjual",
    "ban.tq.title": "Perlukan bantuan dengan pesanan ini?",
    "ban.tq.body": "Tanya Bantuan: akses, kelas, resit atau bayaran. Jawapan serta-merta.",
    "ban.tq.cta": "Chat dengan Bantuan",
    "ban.acct.help": "Bantuan",
    "ban.done": "Dah selesai",
    "ban.notDone": "Masih ada masalah",
    "ban.thanks": "Terima kasih! Gembira dapat membantu.",
    "ban.retry": "Jawapan tadi tak membantu. Cuba cara lain?",
    "ban.receipt.attach": "Lampirkan resit / gambar",
    "ban.receipt.ready": "Resit dilampirkan. Tekan hantar.",
    "ban.receipt.remove": "Buang gambar",
    "ban.receipt.alt": "Gambar resit",
    "ban.receipt.default": "Ini resit bayaran saya.",
    "ban.receipt.bad": "Gambar ini tidak dapat dibaca. Cuba screenshot lain.",
    "ban.team.title": "Perlu hubungi team kami?",
    "ban.team.body": "Staf akan sambung perbualan ini dan membalas di sini serta melalui emel anda.",
    "ban.team.go": "Sambung dengan staf",
    "ban.team.sent": "Perbualan ini sudah dihantar kepada staf. Mereka akan balas di sini dan melalui emel anda.",
    "ban.contact.title": "Supaya staf boleh balas walaupun anda tutup halaman ini:",
    "ban.contact.name": "Nama",
    "ban.contact.email": "Emel",
    "ban.contact.phone": "No. WhatsApp (pilihan)",
    "ban.contact.send": "Hantar kepada staf",
    "ban.contact.done": "Terima kasih, {name}. Staf akan balas di sini dan ke {email}.",
    "ban.team.closed": "Staf dalam talian 8 pg–5 ptg, Isn–Sab. Mereka akan balas sebaik masuk kerja.",
    "ban.staffLabel": "{name} · Pasukan Sellhiz",
    "ban.staffTyping": "{name} sedang menaip…",
    "ban.withStaff": "Anda sedang chat dengan staf.",
    "ban.withSeller": "Anda sedang chat dengan {name}.",
    "ban.unresolved": "Belum selesai?",
    "ban.unresolved.reminded": "Saya dah ingatkan {name}. Mereka akan balas di sini dan di emel anda.",
    "ban.resent": "Akses dihantar semula ke emel anda. Semak Inbox, Spam atau Promotions.",
    "ban.failed": "Maaf, ada masalah. Cuba lagi sebentar.",
  },
  en: {
    "ban.open": "Open Help",
    "ban.close": "Close Help",
    "ban.restart": "Start over",
    "ban.name": "Sellhiz Help",
    "ban.online": "Instant answers · staff online",
    "ban.offline": "Instant answers · staff 8am–5pm, Mon–Sat",
    "ban.hello": "Hi! Ask anything about your order, class or packages. I answer right away.",
    "ban.ph": "Type your question…",
    "ban.send": "Send",
    "ban.chip.order": "Check my order",
    "ban.chip.access": "Didn't get access",
    "ban.chip.class": "Class link",
    "ban.chip.sales": "Packages & prices",
    "ban.chip.login": "Can't sign in",
    "ban.q.sales": "What are the Sellhiz packages and prices?",
    "ban.q.order": "I want to check my order",
    "ban.tech.prompt": "What's the technical problem? Type it below, or pick the closest:",
    "ban.tech.login": "I can't sign in",
    "ban.tech.code": "The code didn't reach my email",
    "ban.tech.pay": "An error when paying",
    "ban.send.title": "Send access to your email",
    "ban.send.note": "Type the email you bought with. Access and class links go straight to it, no code.",
    "ban.send.btn": "Send to my email",
    "ban.send.done": "Done. If {email} has a purchase, the access and class links are on their way to it. Check Inbox, Spam or Promotions in 2 minutes.",
    "ban.send.other": "Not arrived? Try another email",
    "ban.send.withCode": "Check my order with a code",
    "ban.verify.title": "Confirm the email you bought with",
    "ban.verify.note": "I'll send a 6-digit code to it.",
    "ban.verify.email": "you@email.com",
    "ban.verify.send": "Send code",
    "ban.verify.sending": "Sending…",
    "ban.verify.code": "Enter the 6-digit code",
    "ban.verify.check": "Confirm",
    "ban.verify.again": "Send the code again",
    "ban.verify.done": "Email {email} confirmed.",
    "ban.verify.typo": "Mistyped your email at checkout?",
    "ban.verify.titleRight": "Confirm your correct email",
    "ban.verify.noteRight": "I'll send a code to the correct email, then ask for the last 4 digits of your phone to find your order.",
    "ban.fix.title": "Find the order under the mistyped email",
    "ban.fix.note": "Enter the last 4 digits of the phone number you gave at checkout.",
    "ban.fix.phone": "Last 4 phone digits",
    "ban.fix.typed": "The email you typed then (if you remember)",
    "ban.fix.go": "Find & fix",
    "ban.fix.busy": "Searching…",
    "ban.fix.miss": "No order matches those 4 digits. Tries left: {n}.",
    "ban.fix.done": "Done! {n} order(s) are now under {email}. The access links were sent to it again.",
    "ban.fix.pending": "Found {n} order(s) under {old}. Staff will confirm and move them to {email}, usually within office hours. We'll tell you here.",
    "ban.fix.staff": "I've passed this to our staff to check. They'll reply here and by email.",
    "ban.acct.hello": "Hi {name}. I know your purchases, so there's no need to confirm your email.",
    "ban.acct.helloNoName": "Hi! I know your purchases, so there's no need to confirm your email.",
    "ban.tile.akses": "My access",
    "ban.tile.kelas": "Class & WhatsApp",
    "ban.tile.rakaman": "Recordings",
    "ban.tile.sijil": "Certificate",
    "ban.tile.resit": "Receipts",
    "ban.tile.emel": "Change email",
    "ban.tile.akses.q": "Where is my product access?",
    "ban.tile.kelas.q": "Where are my class and WhatsApp links?",
    "ban.tile.rakaman.q": "Are the class recordings ready?",
    "ban.tile.sijil.q": "How do I get my certificate?",
    "ban.tile.resit.q": "I need a receipt",
    "ban.tile.emel.q": "I want to change my account email",
    "ban.tile.akses.a": "Here is everything you bought. Tap to open it.",
    "ban.tile.akses.none": "No active access on this account yet. If you just paid, it arrives within a few minutes.",
    "ban.tile.kelas.a": "Your next class:",
    "ban.tile.kelas.none": "No upcoming classes in your purchases.",
    "ban.tile.kelas.when": "{when} · Zoom",
    "ban.tile.rakaman.a": "The recordings are ready.",
    "ban.tile.rakaman.notYet": "Recordings aren't ready yet. They're uploaded after the class ends.",
    "ban.tile.rakaman.none": "No classes in your purchases.",
    "ban.tile.rakaman.sub": "Watch on your access page",
    "ban.tile.sijil.a": "Your certificates:",
    "ban.tile.sijil.later": "Certificates open after the class ends, {when}.",
    "ban.tile.sijil.none": "No certificates for your purchases.",
    "ban.tile.sijil.name": "Name on certificate: {name}",
    "ban.tile.sijil.ready": "Ready to claim",
    "ban.tile.resit.a": "A receipt for each purchase:",
    "ban.tile.resit.none": "No paid purchases yet.",
    "ban.tile.resit.sub": "{date} · {store}",
    "ban.tile.emel.a": "Your account email: {email}. I'll send a code to the new email to confirm it, then all your purchases move to it.",
    "ban.tile.emel.title": "Change account email",
    "ban.tile.emel.sub": "{n}-digit code to the new email",
    "ban.tile.type.digital": "Digital product · {store}",
    "ban.tile.type.kelas": "Class · {store}",
    "ban.tile.type.physical": "Physical product · {store}",
    "ban.tile.btn.open": "Open",
    "ban.tile.btn.resend": "Send to email",
    "ban.tile.btn.zoom": "Join Zoom",
    "ban.tile.btn.wa": "WhatsApp group",
    "ban.tile.btn.watch": "Watch",
    "ban.tile.btn.claim": "Claim certificate",
    "ban.tile.btn.viewCert": "View certificate",
    "ban.tile.btn.certName": "Change name on certificate",
    "ban.tile.btn.pdf": "Download PDF",
    "ban.tile.btn.newEmail": "Enter new email",
    "ban.tile.foot": "0 tokens · answered from your own purchases",
    "ban.acct.new": "new.email@you.com",
    "ban.acct.send": "Send code",
    "ban.acct.code": "Enter the {n}-digit code",
    "ban.acct.confirm": "Change email",
    "ban.acct.sentTo": "Code sent to {email}.",
    "ban.acct.done": "Your account email is now {email}. All your purchases moved with it.",
    "ban.acct.doneStaff": "Your account email is now {email}. Some purchases need a staff check; they'll reply here.",
    "ban.acct.others": "Purchases from other stores are answered by that store's seller.",
    "ban.acct.contact": "Contact seller",
    "ban.tq.title": "Need help with this order?",
    "ban.tq.body": "Ask Bantuan about access, classes, receipts or payment. Instant answers.",
    "ban.tq.cta": "Chat with Bantuan",
    "ban.acct.help": "Help",
    "ban.done": "That's sorted",
    "ban.notDone": "Still have a problem",
    "ban.thanks": "Thanks! Glad I could help.",
    "ban.retry": "That didn't help. Try another way?",
    "ban.receipt.attach": "Attach a receipt / picture",
    "ban.receipt.ready": "Receipt attached. Tap send.",
    "ban.receipt.remove": "Remove picture",
    "ban.receipt.alt": "Receipt picture",
    "ban.receipt.default": "This is my payment receipt.",
    "ban.receipt.bad": "This picture could not be read. Try another screenshot.",
    "ban.team.title": "Need our team?",
    "ban.team.body": "Staff will pick up this conversation and reply here and by email.",
    "ban.team.go": "Talk to staff",
    "ban.team.sent": "This conversation has gone to our staff. They'll reply here and by email.",
    "ban.contact.title": "So our staff can reply even if you close this page:",
    "ban.contact.name": "Name",
    "ban.contact.email": "Email",
    "ban.contact.phone": "WhatsApp number (optional)",
    "ban.contact.send": "Send to staff",
    "ban.contact.done": "Thank you, {name}. Staff will reply here and to {email}.",
    "ban.team.closed": "Staff are online 8am–5pm, Mon–Sat. They'll reply as soon as they're in.",
    "ban.staffLabel": "{name} · Sellhiz team",
    "ban.staffTyping": "{name} is typing…",
    "ban.withStaff": "You're chatting with staff.",
    "ban.withSeller": "You're chatting with {name}.",
    "ban.unresolved": "Not sorted yet?",
    "ban.unresolved.reminded": "I've reminded {name}. They'll reply here and by email.",
    "ban.resent": "Access resent to your email. Check Inbox, Spam or Promotions.",
    "ban.failed": "Sorry, something went wrong. Try again in a moment.",
  },
};
